import * as React from "react";
import { useUrlState } from "./use-url-state";

// 검색 입력을 URL 쿼리에 동기화. 인풋은 로컬(IME 조합 보존), URL/커밋값은 디바운스.
export function useSearchField(key: string): {
  input: string;
  setInput: (v: string) => void;
  committed: string;
} {
  const [urlValue, setUrlValue] = useUrlState(key, "");
  const [input, setInput] = React.useState(urlValue);
  React.useEffect(() => {
    const t = setTimeout(() => setUrlValue(input), 300);
    return () => clearTimeout(t);
  }, [input, setUrlValue]);
  // 뒤로가기 등 외부에서 URL 이 바뀌면 인풋에 반영(값이 다를 때만).
  React.useEffect(() => {
    setInput((cur) => (cur === urlValue ? cur : urlValue));
  }, [urlValue]);
  return { input, setInput, committed: urlValue };
}
